module.exports = __webpack_public_path__ + "static/img/27.a66afa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/27.jpg
// module id = 9ZXL
// module chunks = 1